import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/@babel/runtime/regenerator/index.js";
import React, { useEffect } from 'react';
import { Avatar, Button, Menu, Dropdown } from 'antd';
import Link from 'next/link';
import { Hub } from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';
import endUserMessages from 'utils/endUserMessages';
import { resetTrackingId } from 'utils/tracking';
import handleError from 'utils/http/handleError';
import { loadUser } from 'redux/actions/user';
import { useDispatch, useSelector } from 'react-redux';
var UserButton = function UserButton() {
  var dispatch = useDispatch();
  var user = useSelector(function (state) {
    return state.user.current;
  });
  useEffect(function () {
    Hub.listen('auth', function (_ref) {
      var event = _ref.payload.event;
      switch (event) {
        case 'signIn':
        case 'cognitoHostedUI':
          dispatch(loadUser());
          break;
        case 'signOut':
          resetTrackingId();
          break;
        case 'signIn_failure':
        case 'cognitoHostedUI_failure':
          handleError('error', endUserMessages.ERROR_SIGN_IN);
          break;
        default:
          break;
      }
    });
  }, []);
  var menuItems = [{
    type: 'group',
    label: "Signed in as ".concat(user === null || user === void 0 ? void 0 : user.attributes.name),
    key: 'singed-in-username'
  }, {
    disabled: true,
    label: 'Your profile',
    key: 'user-profile'
  }, {
    label: /*#__PURE__*/React.createElement(Link, {
      href: "/settings/profile"
    }, "Settings"),
    key: 'user-settings'
  }, {
    type: 'divider'
  }, {
    label: 'Sign out',
    key: 'user-signout',
    onClick: function () {
      var _onClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              Auth.signOut();
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function onClick() {
        return _onClick.apply(this, arguments);
      }
      return onClick;
    }()
  }];
  return user ? /*#__PURE__*/React.createElement(Dropdown, {
    menu: {
      items: menuItems
    },
    trigger: ['click']
  }, /*#__PURE__*/React.createElement(Button, {
    "aria-label": "User settings",
    type: "text",
    style: {
      border: 'none',
      padding: 0,
      margin: 0
    },
    icon: /*#__PURE__*/React.createElement(Avatar, {
      style: {
        backgroundColor: '#f56a00',
        verticalAlign: 'middle'
      },
      size: "medium"
    }, user.attributes.name[0].toUpperCase())
  })) : /*#__PURE__*/React.createElement(Button, {
    type: "dashed",
    onClick: function onClick() {
      return Auth.federatedSignIn();
    }
  }, "Sign in");
};
UserButton.defaultProps = {};
export default UserButton;